module.exports = __webpack_public_path__ + "img/pl_Ecran 3.1c908c8c.png";